import { useMedia } from "@next-platform/client-common-spicy-ui";
import { useTranslation } from "@next-platform/client-common-core";
import { Accordion, AccordionItem, Spacer } from "@nextui-org/react";

import { LocalizedLink } from "@/components";
import TextStyles from "@/components/common/TextStyles";
import { Col, SpicyButton, Text } from "@/components/customComponents";
import Trans from "@/components/Trans/Trans";

export default function SubcriptionFAQs() {
  const { isMobile } = useMedia();
  const { t } = useTranslation();
  const faqContent = [
    {
      question: t("subscription:page.subscriptionFAQs.upgradeDowngradeQuestion"),
      answer: (
        <>
          <Trans i18nKey="subscription:page.subscriptionFAQs.upgradeDowngradeAnswer1" />
          <br />
          <br />
          <Trans i18nKey="subscription:page.subscriptionFAQs.upgradeDowngradeAnswer2" />
        </>
      ),
    },
    {
      question: t("subscription:page.subscriptionFAQs.cancelPlanQuestion"),
      answer: t("subscription:page.subscriptionFAQs.cancelPlanAnswer"),
    },
    {
      question: t("subscription:page.subscriptionFAQs.retainBenefitsQuestion"),
      answer: t("subscription:page.subscriptionFAQs.retainBenefitsAnswer"),
    },
    {
      question: t("subscription:page.subscriptionFAQs.refundQuestion"),
      answer: (
        <>
          <Trans i18nKey="subscription:page.subscriptionFAQs.refundAnswerBefore" />
          <LocalizedLink to="/refund" className="underline" aria-label="refund-policy">
            <Trans i18nKey="subscription:page.subscriptionFAQs.refundPolicyLink" />
          </LocalizedLink>
          <Trans i18nKey="subscription:page.subscriptionFAQs.refundAnswerAfter" />
        </>
      ),
    },
    {
      key: 5,
      question: t("subscription:page.subscriptionFAQs.moreQuestionsQuestion"),
      answer: (
        <>
          <Trans i18nKey="subscription:page.subscriptionFAQs.moreQuestionsAnswer" /> <br />
          <br />
          <SpicyButton
            as={LocalizedLink}
            color="primary_strong"
            variant="secondary"
            to="https://spicychat.freshdesk.com/support/tickets/new"
            target="_blank"
          >
            <Text variant="md" type="white">
              <Trans i18nKey="subscription:page.subscriptionFAQs.submitTicket" />
            </Text>
          </SpicyButton>
        </>
      ),
    },
  ];

  return (
    <Col>
      <Text b variant={isMobile ? "xxl" : "big"}>
        <Trans i18nKey="subscription:page.subscriptionFAQs.title" />
      </Text>
      <Spacer y={isMobile ? 2 : 8} />
      <Accordion
        variant="splitted"
        className="px-0 gap-6"
        itemClasses={{
          base: "data-[open=true]:!bg-blue-400",
          content: "pt-0 pb-5",
        }}
        fullWidth
      >
        {faqContent.map((d, idx) => (
          <AccordionItem
            key={idx}
            title={d.question}
            classNames={{
              heading: TextStyles.accordion.heading,
              trigger: TextStyles.accordion.trigger,
              title: TextStyles.accordion.title,
              indicator: TextStyles.accordion.indicator,
            }}
          >
            {d.answer}
          </AccordionItem>
        ))}
      </Accordion>
    </Col>
  );
}
